import axios from "axios";
import { returnErrors, clearErrors } from "./errorAction";
import { API_END_POINT } from "../../constants/api";

export const ADD_PAYMENT = "ADD_PAYMENT";

export const EDIT_PAYMENT = "EDIT_PAYMENT";
export const EDIT_PAYMENT_SUCC = "EDIT_PAYMENT_SUCC";
export const EDIT_PAYMENT_FAIL = "EDIT_PAYMENT_FAIL";

export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const DELETE_PAYMENT_SUCC = "DELETE_PAYMENT_SUCC";
export const DELETE_PAYMENT_FAIL = "DELETE_PAYMENT_FAIL";

// editpaymentAct
export const GET_PAYMENTS = "GET_PAYMENTS";
export const ADD_PAYMENT_SUCCESS = "ADD_PAYMENT_SUCCESS";
export const ADD_PAYMENT_FAIL = "ADD_PAYMENT_FAIL";
export function addPayment(paymentData, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const values = {
      ...paymentData,
      payment_date: paymentData.payment_date.format("YYYY-MM-DD"),
    };
    const body = JSON.stringify(values);
    axios
      .post(
        `${API_END_POINT}/api/company/contract/payment/register`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: ADD_PAYMENT,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Add payment Successfully", 201, "ADD_PAYMENT_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_PAYMENT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editpaymentAct(updatedPayment, payment_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const values = updatedPayment.payment_date
      ? {
          ...updatedPayment,
          updatedPayment: updatedPayment.updatedPayment.format("YYYY-MM-DD"),
        }
      : updatedPayment;
    const body = JSON.stringify(values);
    axios
      .put(
        `${API_END_POINT}/api/company/contract/payment/update/${payment_id}`,
        body,
        config
      )
      .then((res) =>
        dispatch({
          type: EDIT_PAYMENT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Payment Edit Successfully", 201, "EDIT_PAYMENT_SUCC")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "EDIT_PAYMENT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function deletePayment(payment_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .delete(
        `${API_END_POINT}/api/company/contract/payment/delete/${payment_id}/${company_id}`,

        config
      )
      .then((res) =>
        dispatch({
          type: DELETE_PAYMENT,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Payment Delete Successfully", 201, "DELETE_PAYMENT_SUCC")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DELETE_PAYMENT_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function getPayments(contract_id, company_id, token) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(
        `${API_END_POINT}/api/company/contract/payment/get/${contract_id}/${company_id}`,
        config
      )
      .then((res) =>
        dispatch({
          type: GET_PAYMENTS,
          payload: res.data,
        })
      )
      .catch((err) => console.log("Error", err));
  };
}
